export const CustomColors = {
    primary: "#1976d2",
    secondary: "#dc004e",
    background: "#f5f5f5",
    text: "#333333",
    border: "#eeeeee",
    blue1: "#123763",
};